export const HEIGHT_DEFAULT_AUDIO_WAVEFORM = 80;

export const AUDIO_FILE_EXTENSIONS = ["mp3"];

